const eventsToHideBines = [260200, 260204, 260205];

export const shouldEventHideBines = (eventId) =>
  eventsToHideBines.includes(eventId);
